import { useTranslation } from 'react-i18next';
import CashbackStreakPill from './CashbackStreakPill';
import Streak from './Streak';
import styles from './StreakBanner.module.scss';

const StreakBanner = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.streakBannerRoot} role="banner" aria-label="Streak banner">
      <div className={styles.streakBannerTitle} role="heading">
        {t('paymentConfirmation.streak.startYourStreak')}
      </div>
      <div className={styles.streaks} role="group" aria-label="Streak progress">
        <div className={styles.streaksWrapper} role="list" aria-label="Streak items">
          <Streak activeStreak />
          <Streak />
          <Streak />
          <Streak />
          <Streak />
        </div>
        <CashbackStreakPill />
      </div>
    </div>
  );
};

export default StreakBanner;
